import { createReducer } from '@reduxjs/toolkit';
import {
    SET_POLL_RESPONSES,
    SET_POLL_QUESTION,
    SET_POLL_TOTAL_VOTES,
    SAVE_POLL_VOTE,
    SET_SELECTED_ID,
    SET_POLL_ID,
} from '../actions/PollActions';

const initialState = {
    dataResponse: [],
    pollQuestion: null,
    totalVote: 0,
    pollId: null,
    voteId: false,
    selectedId: null,
};

const poll = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_POLL_RESPONSES, (state, action) => {
            state.dataResponse = action.json;
        })
        .addCase(SET_POLL_QUESTION, (state, action) => {
            state.pollQuestion = action.quets;
        })
        .addCase(SET_POLL_ID, (state, action) => {
            state.pollId = action.pollId;
        })
        .addCase(SET_POLL_TOTAL_VOTES, (state, action) => {
            state.totalVote = action.total;
        })
        .addCase(SET_SELECTED_ID, (state, action) => {
            state.selectedId = action.selectedId;
        })
        .addCase(SAVE_POLL_VOTE, (state, action) => {
            state.voteId = action.voteId;
        });
});

export default poll;
